import React from "react";
import { Info } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "../components/ui/tooltip";

export function InfoTooltip({ text, className = "", side = "top" }) {
  if (!text) return null;
  return (
    <Tooltip delayDuration={150}>
      <TooltipTrigger asChild>
        <span
          className={`inline-flex items-center text-muted-foreground hover:text-foreground cursor-help ${className}`}
          data-testid="info-tooltip-trigger"
        >
          <Info className="w-3 h-3" strokeWidth={1.8} />
        </span>
      </TooltipTrigger>
      <TooltipContent side={side} className="max-w-[240px] text-xs leading-snug">
        {text}
      </TooltipContent>
    </Tooltip>
  );
}
